import { ntbFlowActionType } from '../../actionTypes';

const initialState = {
  applicationId: undefined,
  selectedNtbLender: undefined,
  step: 'initial',
  creditApplicationStatusResponse: undefined,
  lenderWindowUrl: undefined,
  merchantId: undefined,
  lenderList: undefined,
  isUserPreEligibilityDone: false,
  userPreEligibilityData: undefined,
};

const ntbFlow = (state = initialState, action) => {
  switch (action.type) {
    case ntbFlowActionType.NTB_SET_STEP:
      const { step } = action.payload || {};

      if (!step) return initialState;

      return {
        ...state,
        step,
      };

    case ntbFlowActionType.NTB_SET_LENDER:
      const { selectedNtbLender } = action.payload || {};

      return {
        ...state,
        selectedNtbLender,
      };

    case ntbFlowActionType.NTB_SET_APPLICATION_ID:
      const { applicationId } = action.payload || {};

      if (!applicationId)
        return {
          ...state,
          applicationId: undefined,
          creditApplicationStatusResponse: undefined,
          lenderWindowUrl: undefined,
        };

      return {
        ...state,
        applicationId,
      };

    case ntbFlowActionType.NTB_SET_FILTER_SELECTED_REJECTED_LENDER:
      if (state.lenderList && state.selectedNtbLender) {
        return {
          ...state,
          lenderList: state.lenderList.filter(
            (lender) => lender.lenderId !== state.selectedNtbLender.lenderId,
          ),
          selectedNtbLender: undefined,
        };
      }
      return state;

    case ntbFlowActionType.NTB_SET_LENDER_WINDOW_URL:
      const { lenderWindowUrl } = action.payload || {};

      return {
        ...state,
        lenderWindowUrl,
      };

    case ntbFlowActionType.NTB_SET_CREDIT_APPLICATION_STATUS_RESPONSE:
      const { creditApplicationStatusResponse } = action.payload || {};

      if (!creditApplicationStatusResponse)
        return {
          ...state,
          creditApplicationStatusResponse: undefined,
          step: state.step,
        };

      return {
        ...state,
        creditApplicationStatusResponse,
      };

    case ntbFlowActionType.NTB_SET_MERCHANT_ID:
      const { merchantId } = action.payload || {};

      return {
        ...state,
        merchantId,
      };

    case ntbFlowActionType.NTB_SET_PRE_ELIGIBLE_LENDERS:
      const { lenderList } = action.payload || {};

      return {
        ...state,
        lenderList,
      };

    case ntbFlowActionType.NTB_SET_PRE_FILLED_ELIGIBLE_LENDERS:
      const { preEligibileLenders, isUserPreEligibilityDone } =
        action.payload || {};

      return {
        ...state,
        lenderList: preEligibileLenders,
        isUserPreEligibilityDone,
      };

    case ntbFlowActionType.NTB_SET_USER_PRE_FILL_DATA:
      const { userPreEligibilityData } = action.payload || {};

      return {
        ...state,
        userPreEligibilityData,
      };

    case ntbFlowActionType.NTB_SET_RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default ntbFlow;



// WEBPACK FOOTER //
// ./reducer/ntbFlow/index.js